import {
  Avatar,
  Box as MuiBox,
  Stack as MuiStack,
  type StackProps,
} from "@mui/material";
import { styled } from "@mui/material/styles";

export const Root = styled(MuiStack)<StackProps>(({ theme }) => ({
  flexDirection: "row",
  gap: theme.spacing(2),
  alignItems: "flex-start",
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
    gap: theme.spacing(1.5),
    alignItems: "flex-start",
  },
}));

export const ContentBox = styled(MuiBox)(({ theme }) => ({
  flex: 1,
  [theme.breakpoints.down("md")]: {
    width: "100%",
  },
}));

export const InnerStack = styled(MuiStack)(({ theme }) => ({
  gap: theme.spacing(4),
  [theme.breakpoints.down("md")]: {
    gap: theme.spacing(2),
  },
}));

export const TitleStack = styled(MuiStack)(({ theme }) => ({
  gap: theme.spacing(1.5),
  [theme.breakpoints.down("md")]: {
    gap: theme.spacing(1),
  },
}));

export const TitleRow = styled(MuiStack)(({ theme }) => ({
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  gap: theme.spacing(1),
  flexWrap: "wrap",
}));

export const EventIcon = styled(Avatar)(() => ({
  width: 64,
  height: 64,
}));
